import React from 'react';

const DesktopIcon = ({ label, onClick, icon: Icon, color }) => {
  return (
    <div
      onClick={onClick}
      className="flex flex-col items-center justify-center w-[88px] gap-1 cursor-pointer group rounded-lg transition-colors hover:bg-black/5 p-2"
    >
      <div className="relative transition-transform duration-200 group-active:scale-95">
        {Icon && (
          <div className="relative filter drop-shadow-lg">
            {/* Use the passed color, but ensure it pops. If no color, use a default blue/folder color */}
            <div className="p-3 rounded-xl bg-gradient-to-br from-white to-gray-100 shadow-md">
              <Icon
                className={`w-8 h-8 ${color ? color.replace('fill-', 'text-') : 'text-blue-500'}`}
                strokeWidth={1.5}
              />
            </div>
          </div>
        )}
      </div>
      <span className="text-[13px] font-medium text-center leading-tight text-slate-700 px-2 py-0.5 rounded-md mix-blend-multiply group-hover:bg-black/5 transition-colors">
        {label}
      </span>
    </div>
  );
};

export default DesktopIcon;
